import { render, staticRenderFns } from "./SocialSummaryPost.vue?vue&type=template&id=5dbad013&"
import script from "./SocialSummaryPost.vue?vue&type=script&lang=js&"
export * from "./SocialSummaryPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports